import { Menu, Text } from '@mantine/core';

import { type ShortcutSectionDefinition } from 'app/modules/wallforming/components/scenes/toolbar/shortcuts/shortcutList';

interface ShortcutGroupProps {
    definition: ShortcutSectionDefinition;
    group: ShortcutSectionDefinition['groups'][number];
    startIndex: number;
}

export const ShortcutGroup = ({ definition, group, startIndex }: ShortcutGroupProps) => (
    <>
        <Menu.Divider className="mb-2" />
        {group.label && <div className="text-sm font-medium pl-1">{group.label}:</div>}
        {group.shortcuts.map((shortcut, shortcutOffset) => (
            <Menu.Item
                key={shortcut.description}
                className="pointer-events-none"
                rightSection={
                    <Text
                        className={`action-menu-entry-decoration-text text-right ${definition.shortcutWidthClassName} text-[13px]`}
                    >
                        {shortcut.shortcut}
                    </Text>
                }
            >
                {startIndex + shortcutOffset + 1}. {shortcut.description}
            </Menu.Item>
        ))}
    </>
);
